import { Link, useParams } from 'react-router-dom';
import { E2NTableCell } from '../../../../components/Table';
import { Antrag, Arbeitszeit } from '../../entities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { memo } from 'react';
import { useIsMonatAbgeschlossen } from '../../hooks/useIsMonatAbgeschlossen';
import { Button } from '@e2n/ui';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export const EditCell = memo(function EditCell({
  arbeitszeit,
}: {
  arbeitszeit: Arbeitszeit | Antrag;
}) {
  const { year, month, day } = useParams();
  const { currentStandort } = useStandortContext();
  const isMonatAbgeschlossen = useIsMonatAbgeschlossen(
    `${year}-${month}-${day}`,
    currentStandort.id,
  );

  return (
    <E2NTableCell className="rounded-r-lg w-40 p-2">
      <Link
        to={`/arbeitszeiten/uebersicht/${year}/${month}/${day}/sheet/edit/${
          arbeitszeit instanceof Arbeitszeit &&
          arbeitszeit.antraege?.length > 0 &&
          arbeitszeit.antraege[0].offen
            ? arbeitszeit.id + `/antraege`
            : arbeitszeit.id
        }`}>
        <Button
          size="icon"
          variant="ghost-primary"
          disabled={isMonatAbgeschlossen}
          className="flex items-center gap-2">
          <FontAwesomeIcon
            icon={isMonatAbgeschlossen ? faLock : faEdit}
            className="text-primary-blue-600"
          />
        </Button>
      </Link>
    </E2NTableCell>
  );
});
